import { useCallback, useEffect, useState } from "react";

import { getVideoPlayback } from "../services/videoPlaybackService";

export const useVideoPlayback = (videoTag, canWatch) => {
  const [playback, setPlayback] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setPlayback(null);
    setError("");
  }, [videoTag, canWatch]);

  const loadPlayback = useCallback(async () => {
    if (!videoTag || !canWatch) {
      setPlayback(null);
      return null;
    }

    setLoading(true);
    setError("");

    try {
      const response = await getVideoPlayback(videoTag);

      if (response?.success === false) {
        throw new Error(response.message || "Playback unavailable.");
      }

      const result = response?.playback || response;

      const playbackUrl =
        result?.playbackUrl || result?.videoUrl || result?.url;

      if (!playbackUrl) {
        throw new Error("Video URL is unavailable.");
      }

      const nextPlayback = {
        url: playbackUrl,
        type: result?.playbackType || result?.type || "mp4",
        poster: result?.thumbnailUrl || "",
      };

      setPlayback(nextPlayback);

      return nextPlayback;
    } catch (requestError) {
      setPlayback(null);
      setError(
        requestError?.response?.data?.message ||
          requestError?.message ||
          "Unable to load video.",
      );

      return null;
    } finally {
      setLoading(false);
    }
  }, [videoTag, canWatch]);

  return {
    playback,
    loading,
    error,
    loadPlayback,
  };
};

export default useVideoPlayback;
